<template>
  <div class="dashboard main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Dashboard</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="header-info">
          <b-col cols="12">
            <div class="box-cj">
              <b-row class="mb-0">
                <b-col class="p-4 text-center">
                  <div class="pointer" @click="setClientTypeSelected('trial')">
                    <p class="info mb-2">Clientes em trial</p>
                    <p :class="'value ' + (clientTypeSelected == 'trial' ? 'active' : '')">{{ dashboardData.clientsTrial.length }}</p>
                  </div>
                </b-col>
                <b-col class="p-4 text-center">
                  <div class="pointer" @click="setClientTypeSelected('trialend')">
                    <p class="info mb-2">Clientes trial end</p>
                    <p :class="'value ' + (clientTypeSelected == 'trialend' ? 'active' : '')">{{ dashboardData.clientsTrialEnd.length }}</p>
                  </div>
                </b-col>
                <b-col class="p-4 text-center">
                  <div class="pointer" @click="setClientTypeSelected('situationChange')">
                    <p class="info mb-2">Clientes c/ mudança de situação</p>
                    <p :class="'value ' + (clientTypeSelected == 'situationChange' ? 'active' : '')">{{ dashboardData.clientsWithSituationChange.length }}</p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="clientTypeSelected != null">
          <b-col>
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">{{ getInfoBySelectedClientType('title') }}</p>

                  <div>
                    <i class="far fa-times pointer" @click="setClientTypeSelected(null)"></i>
                  </div>
                </div>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th>Telefone</th>
                      <th>Data de cadastro</th>
                      <th>Último acesso</th>
                      <th>Último agendamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <router-link tag="tr" :to="'/clientes/'+client.id" v-for="client in getInfoBySelectedClientType('data')" :key="client.id">
                      <td><i class="fa fa-circle mr-2" :title="getSituation(client).name" :class="'situation-indicator ' + getSituation(client).class"></i>{{ client.name }}</td>
                      <td>{{ client.email }}</td>
                      <td>{{ (client.cellphone != '')?client.cellphone:client.telephone }}</td>
                      <td>{{ moment(client.created_at).format('DD/MM/YYYY') }}</td>
                      <td>{{ client.last_access != null ? moment(client.last_access).format('DD/MM/YYYY') : '' }}</td>
                      <td>{{ client.last_appointment_created_at != null ? moment(client.last_appointment_created_at).format('DD/MM/YYYY') : '' }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="getInfoBySelectedClientType('data').length == 0" class="text-center sub-title">A sua busca por clientes não encontrou nenhum resultado.</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dashboardData: {
          clientsTrial: [],
          clientsTrialEnd: [],
          situationChange: [],
        },

        situationOptions: [
          { value: 'USING', name: 'Usando', class: 'using' },
          { value: 'STOPPED_USING', name: 'Deixou de usar', class: 'stopped-using' },
          { value: 'NOT_USING_ANYMORE', name: 'Não usa mais', class: 'not-using-anymore' },
          { value: 'NEVER_USED', name: 'Não usou', class: 'never-used' }
        ],

        clientTypeSelected: 'trial',
      }
    },
    async mounted () {
      this.getDashboard();
    },
    methods: {
      async getDashboard() {
        this.eventBus.$emit('IS_LOADING', true);

        await this.api.getDashboard({}).then(res => {
          this.dashboardData = res.data;

          this.eventBus.$emit('IS_LOADING', false);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Dashboard', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);

          this.$swal('Ops...', 'Não conseguimos carregar os dados! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Dashboard', err.response);
        });
      },
      setClientTypeSelected(status) {
        this.clientTypeSelected = status;
      },
      getInfoBySelectedClientType(type) {
        let title = '';
        let data = [];
        switch (this.clientTypeSelected) {
          case 'trial':
            title = 'Clientes em trial';
            data = this.dashboardData.clientsTrial;
            break;
          case 'trialend':
            title = 'Clientes trial end';
            data = this.dashboardData.clientsTrialEnd;
            break;
          case 'situationChange':
            title = 'Clientes com mudança de situação';
            data = this.dashboardData.clientsWithSituationChange;
            break;
        }

        return (type == 'title')?title:data;
      },

      getSituation(client) {
        let situation = '';
        if(client.last_appointment_created_at == null)
          situation = 'NEVER_USED';
        else if(client.days_without_use <= 4)
          situation = 'USING';
        else if(client.days_without_use <= 15)
          situation = 'STOPPED_USING';
        else
          situation = 'NOT_USING_ANYMORE';

        return this.situationOptions.find(g => g.value == situation);
      },
    }
  }
</script>

<style lang="scss">
  .main-content-cj {
    &.dashboard {
      padding: 20px 0;

      .header-info {
        p {
          margin: 0;
        }

        .info {

        }

        .value {
          font-size: 32px;
          color: $linkWater;

          &.active {
            color: $curiousBlue;
          }
        }
      }

      .box-cj {
        .content {
          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 15px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }

            .situation-indicator {
              font-size: 12px;

              &.using {
                color: $ufoGreen;
              }
              &.stopped-using {
                color: $yellowSea;
              }
              &.not-using-anymore {
                color: $dullRed;
              }
              &.never-used {
                color: #333333;
              }
            }
          }
        }
      }
    }
  }
</style>
